import React from "react";
 import { useNavigate } from 'react-router-dom';
 import '../Assets/Additionalcss/OTP.css'
 import OTPInput  from "otp-input-react";
 import { useState } from 'react';


const OtpPage=()=>{

  
    const navigate = useNavigate();

    const [OTP, setOTP] = useState("");
   

    const nav=(e)=>{
        e.preventDefault()

        var otpvalue = localStorage.getItem('otp')
 if(!OTP){
    document.getElementById('err').innerHTML = "Type your 4 digit security code"
    document.getElementById('errA').innerHTML = ""
 }
      else if(otpvalue!=OTP){
        document.getElementById('err').innerHTML = ""
      document.getElementById('errA').innerHTML = "Enter valid OTP"

        }
    
 else{
    document.getElementById('errA').innerHTML = ""
         navigate("/Resetpassword"); 
     } 
    }
   

    return(

          <div className="main-container">

                <div className="otpdiv">
    <h3 class="login-title">OTP Verification</h3> 
    <span className="spanErr"id="err"></span> 
 <span className="spanErr" id="errA"></span> 
<br></br>
    <form>
      <div  className="otp-input">
       
        <OTPInput  value={OTP} id="Input" onChange={setOTP} autoFocus OTPLength={4} otpType="number" disabled={false} />
        
      </div>

     <br></br>

      <div className="buttons">
                <button type="Submit"  onClick={nav}className="button">Submit</button>
{/* <button type="Submit" className="button2">Resend OTP</button> */}
</div>
    </form>
</div>
                </div>
                // </div>
             
   
);
}
export default OtpPage;